import script from "./CatalogDataSingleInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogDataSingleInput.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogDataSingleInput.vue?vue&type=style&index=0&id=1d038c90&lang=scss"

const __exports__ = script;

export default __exports__